export {
  DISCONNECT,
  RECONNECT,
  RETRY,
  SCHEDULE,
  OFFLINE,
  ONLINE,
} from '../websocket-plus';

export const RECONNECT_ERROR = 'reconnecterror';
